import React from 'react'
import { toast } from '@CommonComponents/toast'
import { notebook as endpoints } from '@URLS'
import { client } from '@Utils'
import { useStateValue } from './state'
import { Highlight } from './Highlight'

const MAX_HIGHLIGHTS = 100

export const HighlightsContainer = () => {
  let [currentState, dispatch] = useStateValue()
  const [loadingMore, setLoadingMore] = React.useState(false)

  const loadMore = async () => {
    setLoadingMore(true)
    try {
      const resp = await client.post(endpoints.filterHighlights(), {
        filters: currentState.filters,
        pageId: currentState.pageId,
        offset: currentState.highlights.length,
      })
      dispatch({ type: 'appendHighlights', payload: resp.data.highlights })
      dispatch({ type: 'updateHighlightTotal', payload: resp.data.total })
      dispatch({
        type: 'updateHasMore',
        payload:
          currentState.highlights.length + resp.data.highlights.length <
          resp.data.total,
      })
    } catch (err) {
      toast.error(String(err))
    } finally {
      setLoadingMore(false)
    }
  }

  const canLoadMore =
    currentState.hasMore && currentState.highlights.length < MAX_HIGHLIGHTS

  return (
    <div className="pb-5">
      {currentState.highlights.length > 0 ? (
        currentState.highlights.map(hl => (
          <Highlight
            hId={hl.hId}
            sectionTitle={hl.sectionTitle}
            tags={hl.tags}
            cssClass={hl.cssClass}
            contentString={hl.contentString}
            note={hl.note}
            anchor={hl.anchor}
            key={hl.hId}
          />
        ))
      ) : (
        <div className="text-center">
          <p className="mt-4">
            {currentState.message
              ? currentState.message
              : 'No highlights found.'}
          </p>
        </div>
      )}
      {canLoadMore && (
        <div className="d-flex justify-content-center mt-2">
          <button
            className="btn btn-link"
            onClick={loadMore}
            disabled={loadingMore}
          >
            {loadingMore ? 'Loading...' : 'Load more'}
          </button>
        </div>
      )}
    </div>
  )
}
